import React from 'react'

import { FindParcelBox } from '/react4xp/parts/find-parcel-box/find-parcel-box'

export default (props) => <FindParcelBox {...props} />
